import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShopNavigation } from '../components/shop/ShopNavigation';
import { ShopFooter } from '../components/shop/ShopFooter';
import { ProductGrid } from '../components/shop/ProductGrid';
import { ShippingMessage } from '../components/shop/ShippingMessage';
import { getProducts } from '../lib/shopify';
import type { Product } from '../types/commerce';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Shop() {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    document.title = 'Shop — BEAT Soda';
    let active = true;
    getProducts().then(result => {
      if (active) setProducts(result);
    }).catch(() => {
      if (active) setFailed(true);
    }).finally(() => {
      if (active) setLoading(false);
    });
    return () => {
      active = false;
    };
  }, []);
  return <div className="flex min-h-screen w-full flex-col bg-beat-black font-sans text-white antialiased" data-id="element-388" data-mp="3dj8p6v7ixlvi">
      <ShopNavigation data-id="element-389" data-mp="3iicydlug7jlu" />

      <main className="flex-1 px-5 py-14 md:px-10 md:py-20" data-id="element-390" data-mp="3ihjzf71qdye9">
        <div className="mx-auto max-w-[1200px]" data-id="element-391" data-mp="3n9uyk7ondg5r">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: EASE
        }} data-id="element-392" data-mp="3nc7nj4stoqsb">
            <p className="mb-6 text-[11px] font-medium uppercase tracking-[0.2em] text-beat-red sm:text-sm sm:tracking-widest" data-id="element-393" data-mp="2un0hlkr1gyx1">
              Shop
            </p>
            <h1 className="max-w-[16ch] text-[12vw] font-medium leading-[1.05] tracking-tight sm:text-5xl md:text-6xl lg:text-7xl" data-id="element-394" data-mp="33lm41qzmsy33">
              Bring BEAT to the moment.
            </h1>
            <p className="mt-6 max-w-md text-lg leading-relaxed text-white/55" data-id="element-395" data-mp="iw53996senn6">
              Delivered by the case. Cold, dry, bittersweet — and ready for
              whatever you are doing tonight.
            </p>
            <ShippingMessage className="mt-8" data-id="element-396" data-mp="2jxcq338f8124" />
          </motion.div>

          <div className="mt-16 md:mt-20" data-id="element-397" data-mp="2fwswuaqyxhl9">
            {failed ? <p className="text-base text-white/50" data-id="element-398" data-mp="2fyltcx7valfj">
                We could not load the shop just now. Refresh and try again.
              </p> : <ProductGrid products={products} loading={loading} data-id="element-399" data-mp="2oy8stdh1dh5y" />}
          </div>
        </div>
      </main>

      <ShopFooter data-id="element-400" data-mp="217wf1lz40q7g" />
    </div>;
}